const LS_KEY_NAME = 'fleetTask_import_upload_id'

export const setFleetTaskImportIdtoLs = (id) => localStorage.setItem(LS_KEY_NAME, id)
export const getFleetTaskImportIdFromLs = () => localStorage.getItem(LS_KEY_NAME)
export const removeFleetTaskyImportIdFromLs = () => localStorage.removeItem(LS_KEY_NAME)
